import { jsx as _jsx } from "react/jsx-runtime";
import MuiTextField from '@mui/material/TextField';
export default function TextField(props) {
    return _jsx(MuiTextField, { ...props });
}
export * from '@mui/material/TextField';
